import React, { useState } from "react";
import { DropDownProps } from "../DropDown";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import useScreenOptionsHooks from "../../../../hooks/useScreenOptionsHooks";
import { VDBIcons } from "@utils/VDBIcons";
import { SpaceType } from "@components/atoms/Spacer/types";
import { getProductThemeFromType } from "@components/common/Header/utils";
import { OptionValue } from "@src/types/DiamondDetail";

const NativeDropDown = ({
  options,
  defaultValue,
  onSelect,
  productType,
  showError,
}: DropDownProps) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);
  const productThemeType = getProductThemeFromType(productType);
  const { theme, t } = useScreenOptionsHooks();
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onSelect(
      event.target.value,
      options.find(
        (option) => (option?.value || option?.slug) === event.target.value
      ) as OptionValue
    );
    setSelectedValue(event.target.value);
    setIsOpen(false);
  };

  return (
    <>
      <div style={{ position: "relative", height: 56 }}>
        <select
          id="browser-dropdown"
          value={defaultValue}
          onChange={handleChange}
          onFocus={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
          style={{
            height: "100%",
            width: "100%",
            boxSizing: "border-box",
            WebkitAppearance: "none",
            MozAppearance: "none",
            paddingLeft: 10,
            borderWidth: 1,
            borderRadius: SpaceType.Extra,
            appearance: "none",
            outlineStyle: "none",
            borderColor: showError
              ? theme["error-01"]
              : isOpen
              ? theme[`${productThemeType}-04`]
              : theme["core-04"],
          }}
        >
          <option value={""} disabled={!!selectedValue}>
            {"Please Select"}
          </option>
          {options?.map((option) => {
            return (
              <option value={option?.value || option?.slug}>
                {t(option?.label ?? "")}
              </option>
            );
          })}
        </select>
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            alignContent: "center",
            pointerEvents: "none",
            paddingRight: 10,
          }}
        >
          <VDBIcon
            size={24}
            color={theme["main-01"]}
            variant={IconsVariant.VDBCustom}
            name={VDBIcons.FILLED_CIRCLE_DOWN}
          />
        </div>
      </div>
    </>
  );
};

export default NativeDropDown;
